module.exports = __webpack_public_path__ + "img/icon-more.34565d3e.svg";